import { PatientPaymentControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface Params {
  cardUuid: string;
  xTENANTID?: string;
}

/**
 * Marks a saved card as the patient's primary card. The backend clears the
 * primary flag from any previously primary card.
 *
 * @author Bhushan Varade
 */
export const useSetPrimaryCard = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientPaymentControllerApi(getConfigObject()).setPrimaryCard(
      params.cardUuid,
      params.xTENANTID
    )
  );
